export default __webpack_public_path__ + "static/pragicts-partnerships-banner-ai-robotics-b4fffd48e978300af188276a6987cb5a.jpg";